import { StatusBar } from 'expo-status-bar';
import { StyleSheet, View, Image, Text } from 'react-native';
import { NavigationContainer, useNavigation } from '@react-navigation/native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { Ionicons } from '@expo/vector-icons';
import { NativeBaseProvider } from 'native-base';
import Fontisto from '@expo/vector-icons/Fontisto';
import { useEffect, useState } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { APP_NAME } from './config/constants';

import HomeScreen from './screens/HomeScreen';
import ChatScreen from './screens/ChatScreen';
import MessageScreen from './screens/MessageScreen';
import GemScreen from './screens/GemScreen';
import ProfileScreen from './screens/ProfileScreen';
import DetailScreen from './screens/DetailScreen';
import ExpertPayScreen from './screens/ExpertPayScreen';
import { UserAPI } from './data/api';
import { persistor, store, useTypedSelector } from './redux/store';
import GemPayScreen from './screens/GemPayScreen';
import ActivityScreen from './screens/ActivityScreen';
import SupportScreen from './screens/SupportScreen';

const Tab = createBottomTabNavigator();
const Stack = createNativeStackNavigator();

function TabNavigator() {
  const [coins, setCoins] = useState(0);
  const dispatch = useDispatch();
  const userCurrent = useTypedSelector((state) => state.userCurrent);

  const getUserInfo = async ()=>{
    UserAPI.getCurrentUser(dispatch);
  };
  
  useEffect(()=>{ getUserInfo(); }, []);

  useEffect(()=>{
    setCoins(userCurrent.coins);
  }, [userCurrent]);
  return (
    <>
      <View style={styles.header}>
        <Image source={require('./assets/favicon.png')} style={styles.logo} />
        <Text style={styles.appName}>{APP_NAME}</Text>
        <View style={styles.nav_right_ctx}>
          <Fontisto name="database" size={12} color="#FFFFFF" />
          <Text style={{ color: '#FFFFFF', fontSize: 14 }}>{coins}</Text>
        </View>
      </View>
      <Tab.Navigator
          screenOptions={({ route }) => ({
            tabBarIcon: ({ focused, color, size }) => {
              let iconName = 'home';
              if (route.name === 'Home') {
                iconName = focused ? 'home' : 'home-outline';
              } else if (route.name === 'Chat') {
                iconName = focused ? 'chatbubble' : 'chatbubble-outline';
              } else if (route.name === 'Gem') {
                iconName = focused ? 'diamond' : 'diamond-outline';
              } else if (route.name === 'Profile') {
                iconName = focused ? 'person' : 'person-outline';
              }
              return <Ionicons name={iconName} size={size} color={color} />;
            },
            tabBarActiveTintColor: '#007AFF',
            tabBarInactiveTintColor: '#FFFFFF',
            tabBarStyle: {
              backgroundColor: 'rgb(25,27,44)',
              borderTopColor: 'rgb(25,27,44)',
            },
            headerShown: false,
          })}
        >
          <Tab.Screen name="Home" component={HomeScreen} />
          <Tab.Screen name="Chat" component={ChatScreen} />
          <Tab.Screen name="Gem" component={GemScreen} />
          <Tab.Screen name="Profile" component={ProfileScreen} />
        </Tab.Navigator>
    </>
  );
}

export default function App() {
  return (
    <NativeBaseProvider>
      <NavigationContainer>

        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <View style={styles.container}>
              <StatusBar style="dark" />
              <Stack.Navigator screenOptions={{ headerShown: false }}>
                {/* <Stack.Screen name="MainTabs" component={TabNavigator} /> */}
                <Stack.Screen name="Detail" component={DetailScreen} />
                <Stack.Screen name="Message" component={MessageScreen} />
                <Stack.Screen name="ExpertPay" component={ExpertPayScreen} />
                <Stack.Screen name="GemPay" component={GemPayScreen} />
                <Stack.Screen name="Profile" component={ProfileScreen} />
                <Stack.Screen name="Activity" component={ActivityScreen} />
                <Stack.Screen name="Support" component={SupportScreen} />
              </Stack.Navigator>
              <PathListener />
            </View>
          </PersistGate>
        </Provider>
        
      </NavigationContainer>
    </NativeBaseProvider>
  );
}
function PathListener() {
  // const navigation = useNavigation();
  // useEffect(() => {
  //   if (location.pathname !== '/') {
  //     navigation.navigate('Detail');
  //   }
  // }, []);

  return null; // 此组件不渲染任何UI
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#191B2C',
    maxWidth: 460,
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  header: {
    flexDirection: 'row',
    paddingLeft: 6,
    paddingRight: 6,
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 50,
    backgroundColor: 'rgb(25,27,44)',
  },
  logo: {
    width: 30,
    height: 30,
    marginRight: 10,
  },
  appName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  nav_button: {
    padding: 6,
    backgroundColor: "transparent"
  },
  nav_right_ctx: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    borderRadius: 20,
    padding: 2,
    paddingLeft: 12,
    paddingRight: 12,
    borderWidth: 1,
    borderColor: "#007AFF",
    borderStyle: "solid"
  }
});
